import * as AccountActions from '../actions/accounts';
import { StoreActions } from '../../types';
import { Account } from '../../../../domain/accounts/Account';

export type AccountClearedBalancesState = Map<Account['uuid'], number>;
export const accountClearedBalances = (state: AccountClearedBalancesState = new Map(), action: StoreActions) => {
    switch (action.type) {
        case AccountActions.LOAD_CLEARED_ACCOUNT_BALANCE:
            state.set(action.payload.accountUUID, action.payload.clearedBalance);
            return new Map(state.entries());

        default:
            return state;
    }
};
